// extracted by mini-css-extract-plugin
module.exports = {"homeConceptMain":"home-concept_homeConceptMain__qEUA4","contentContainer":"home-concept_contentContainer___IDHf","cards":"home-concept_cards__ZLU2x"};